import { ALL_METRICS, NRT_METRICS } from '@contentsquare/metrics';
export const SUPPORTED_ALERT_METRICS = [...ALL_METRICS, ...NRT_METRICS];
export var NumberFormatError;
(function (NumberFormatError) {
    NumberFormatError["Undefined"] = "N/A";
    NumberFormatError["NotANumber"] = "--";
})(NumberFormatError || (NumberFormatError = {}));
//# sourceMappingURL=alert.metric.js.map